<div class="modal--mobile" id="modalConfigMobile" #modalConfigMobile>
    <div class="modal--mobile__content">
        <span class="title">{{title}}</span>
        <span class="description">{{description}}</span>
    </div>
    <div class="modal--mobile__close">
        <span class="vdp-icon-cancelar" (click)="hide()"></span>
    </div>
</div>